import { db } from '../firebase';
import { 
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  getDoc,
  getDocs,
  query,
  orderBy,
  serverTimestamp,
  setDoc
} from 'firebase/firestore';

/**
 * Adiciona uma nova configuração Meta
 * @param {Object} metaConfig - Configuração do Meta
 * @returns {Promise<string>} ID do documento criado
 */
export const insertMetaConfig = async (metaConfig) => {
  // const id1 = metaConfig.track?.split('/')[0]?.trim();
  // const id2 = metaConfig.track?.split('/')[1]?.trim();
  // console.log('ID1:', id1, 'ID2:', id2);
  const path = `meta`;
  try {
    const metaRef = doc(db, path, metaConfig.formId || doc(collection(db, path)).id);
    const docData = {
      ...metaConfig,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };

    await setDoc(metaRef, docData);
    return metaRef.id;
  } catch (error) {
    return null
  }
};

/**
 * Atualiza uma configuração Meta existente
 * @param {string} metaId - ID do documento
 * @param {Object} metaConfig - Dados atualizados
 */
export const updateMetaConfig = async (metaId, metaConfig) => {
  try {
    const metaRef = doc(db, 'meta', metaId);
    
    const updateData = {
      ...metaConfig,
      updatedAt: serverTimestamp()
    };

    await updateDoc(metaRef, updateData);
  } catch (error) {
    // console.error('Erro ao atualizar configuração Meta:', error);
    throw error;
  }
};

/**
 * Remove uma configuração Meta
 * @param {string} metaId - ID do documento
 */
export const deleteMetaConfig = async (metaId) => {
  try {
    // console.log('Deletando configuração Meta:', metaId);
    const metaRef = doc(db, 'meta', metaId);
    await deleteDoc(metaRef);
  } catch (error) {
    // console.error('Erro ao deletar configuração Meta:', error);
    throw error;
  }
};

/**
 * Obtém uma configuração Meta específica
 * @param {string} metaId - ID do documento
 * @returns {Promise<Object|null>} Dados da configuração ou null se não encontrada
 */
export const getMetaConfig = async (metaId) => {
  try {
    const metaRef = doc(db, 'meta', metaId);
    const docSnap = await getDoc(metaRef);

    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      // console.log('Nenhuma configuração encontrada com este ID');
      return null;
    }
  } catch (error) {
    // console.error('Erro ao buscar configuração Meta:', error);
    throw error;
  }
};

/**
 * Lista todas as configurações Meta
 * @returns {Promise<Array>} Array com todas as configurações
 */
export const listMetaConfigs = async () => {
  try {
    const metaCollection = collection(db, 'meta');
    const q = query(metaCollection, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Erro ao listar configurações Meta:', error);
    throw error;
  }
};